import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import getFormattedValues from 'utils/formatValues';

const baseURIAcciones = '/configuraciones/acciones-de-seguimientos-de-registros/';
const baseURIAdjuntos = '/configuraciones/adjuntos-de-seguimientos-de-registros/';
const baseURITiposDeDocumentosAnexos = '/adquisiciones/tipos-de-documentos-anexos/';

const toArray = (d) => (Array.isArray(d) ? d : (d?.results ?? []));

// #region Acciones (ida y vuelta entre el emisor y el receptor de la nota)
export const getAccionesDeSeguimiento = async (seguimientoId, filtros = {}) => {
  try {
    const response = await API.get(baseURIAcciones, {
      params: { seguimiento: seguimientoId, ...filtros },
    });
    return toArray(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

export const postAccionDeSeguimiento = async (values) => {
  try {
    const response = await API.post(baseURIAcciones, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

export const patchAccionDeSeguimiento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURIAcciones}${id}/`, getFormattedValues(values, { clean: false }));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};
// #endregion

// #region Adjuntos (evidencia de la nota)
const formatValuesAdjunto = (values) => getFormattedValues(values, { files: ['documento'], formData: true });

export const getAdjuntosDeSeguimiento = async (seguimientoId) => {
  try {
    const response = await API.get(baseURIAdjuntos, { params: { seguimiento: seguimientoId } });
    return toArray(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

export const postAdjuntoDeSeguimiento = async (values) => {
  try {
    const response = await API.post(baseURIAdjuntos, formatValuesAdjunto(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

export const patchAdjuntoDeSeguimiento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURIAdjuntos}${id}/`, formatValuesAdjunto(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

export const deleteAdjuntoDeSeguimiento = async (id) => {
  try {
    const response = await API.delete(`${baseURIAdjuntos}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const getTiposDeDocumentosAnexos = async () => {
  try {
    const response = await API.get(baseURITiposDeDocumentosAnexos);
    return toArray(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
// #endregion
